import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, DispatchEventClient, DispatchEventReport, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useGetDispatchEventReport(id: number, role: AuthorizationRequestType) {
  return useQuery<DispatchEventReport, ProblemDetails>({
    queryKey: [queryKeys.DispatchEvent.Get, { id }],
    queryFn: () => dispatchEventClient.get(id, role),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetDispatchEventReport;
